import { Badge, Box, Text } from '@wix/design-system';
import { useFormatDate } from '@wix/package-picker-shared';
import React from 'react';
import { useDowngradeModal } from '../../../hooks/useDowngradeModal';
import { SwitchProductModule } from '../../../switch-product.module';
import styles from './CompareProducts.scss';
import { ProductPrice } from './ProductPrice';
// TODO: Refactor?
export const ProductBox = _ref => {
  let {
    title,
    dataHook,
    isCurrentProduct
  } = _ref;
  const {
    t
  } = SwitchProductModule.internals.useTranslations();
  const {
    downgradeDetails
  } = useDowngradeModal();
  const productDetails = isCurrentProduct ? downgradeDetails == null ? void 0 : downgradeDetails.currentPlanDetails : downgradeDetails == null ? void 0 : downgradeDetails.destinationProductDetails;
  const formatPrice = SwitchProductModule.SDK.useFormatPrice();
  const {
    locale
  } = SwitchProductModule.internals.useContext();
  const formatDate = useFormatDate({
    locale
  });
  if (!productDetails) {
    return null;
  }
  const isUnpaid = (downgradeDetails == null ? void 0 : downgradeDetails.downgradeType) === 'GracePeriod';
  const showDiscountMessage = !!(downgradeDetails != null && downgradeDetails.currentPlanDetails.discountedPrice);
  const showProductRenewalMessage = (downgradeDetails == null ? void 0 : downgradeDetails.downgradeType) === 'Extend';
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "360px",
    paddingBottom: "30px",
    dataHook: dataHook,
    className: styles.productBox
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    className: styles.productBoxTitle
  }, title), /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    borderRadius: "4px",
    border: "1px solid #dfe5eb",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    verticalAlign: "middle",
    padding: "SP2 SP4",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    dataHook: "productName"
  }, productDetails.localizedProductName), /*#__PURE__*/React.createElement(ProductPrice, {
    productDetails: productDetails
  }), showDiscountMessage && /*#__PURE__*/React.createElement(Box, {
    visibility: productDetails.discountedPrice ? 'visible' : 'hidden'
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: "discountMessage",
    size: "small",
    weight: "bold"
  }, t('change_plan.change_plan_modal.discounted_price', {
    discountedPrice: formatPrice(productDetails.discountedPrice)
  })))), isUnpaid && /*#__PURE__*/React.createElement(Box, {
    visibility: isCurrentProduct ? 'visible' : 'hidden'
  }, /*#__PURE__*/React.createElement(Badge, {
    skin: "danger"
  }, t('change_plan.change_plan_modal.unpaid').toUpperCase()))), showProductRenewalMessage && /*#__PURE__*/React.createElement(Box, {
    dataHook: "productRenewalMessage",
    backgroundColor: "rgba(240, 244, 247, 0.5)",
    minHeight: "48px",
    paddingLeft: "SP4",
    borderRadius: "0 0 6px 6px",
    borderTop: "1px solid #dfe5eb",
    verticalAlign: "middle",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: "productRenewalMessageDate",
    size: "small"
  }, t('change_plan.change_plan_modal.renews_on', {
    date: formatDate(productDetails.endOfPeriod)
  })), !isCurrentProduct && !!(downgradeDetails != null && downgradeDetails.daysAdded) && /*#__PURE__*/React.createElement(Text, {
    dataHook: "productRenewalMessageDaysAdded",
    size: "small",
    skin: "success"
  }, t('change_plan.change_plan_modal.renew_for_days', {
    amount: downgradeDetails.daysAdded
  })))));
};
//# sourceMappingURL=ProductBox.js.map